export default {
  LOGIN_USER_REQUEST: '@hivemind-common/LOGIN_USER_REQUEST',
  LOGIN_USER_SUCCESS: '@hivemind-common/LOGIN_USER_SUCCESS',
  LOGIN_USER_FAILURE: '@hivemind-common/LOGIN_USER_FAILURE',
  MAGIC_USER_REQUEST: '@hivemind-common/MAGIC_USER_REQUEST',
  MAGIC_USER_SUCCESS: '@hivemind-common/MAGIC_USER_SUCCESS',
  MAGIC_USER_FAILURE: '@hivemind-common/MAGIC_USER_FAILURE',
  LOGOUT_USER: '@hivemind-common/LOGOUT_USER',
  RESET_PASSWORD_REQUEST: '@hivemind-common/RESET_PASSWORD_REQUEST',
  RESET_PASSWORD_FAILURE: '@hivemind-common/RESET_PASSWORD_FAILURE',
  RESET_PASSWORD_SUCCESS: '@hivemind-common/RESET_PASSWORD_SUCCESS',
  VERIFY_RESET_FAILURE: '@hivemind-common/VERIFY_RESET_FAILURE',
  CHANGE_PASSWORD_REQUEST: '@hivemind-common/CHANGE_PASSWORD_REQUEST',
  CHANGE_PASSWORD_FAILURE: '@hivemind-common/CHANGE_PASSWORD_FAILURE',
  CHANGE_PASSWORD_SUCCESS: '@hivemind-common/CHANGE_PASSWORD_SUCCESS',
  REGISTER_USER_REQUEST: '@hivemind-common/REGISTER_USER_REQUEST',
  REGISTER_USER_FAILURE: '@hivemind-common/REGISTER_USER_FAILURE',
  REGISTER_USER_SUCCESS: '@hivemind-common/REGISTER_USER_SUCCESS',
  AUTH_INITIALISATION_START: '@hivemind-common/AUTH_INITIALISATION_START',
  AUTH_INITIALISATION_END: '@hivemind-common/AUTH_INITIALISATION_END'
};